import React, { useState } from 'react';
import BreadcrumbBack from '../../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../../components/button/CustomButton';
import { useNavigate } from 'react-router-dom';
import PaginationDataGrid from '../../../../components/tables/PaginationDataGrid';
import Models from '../../../../components/models/Models';
import AdminLiveClassAccountCE from './AdminLiveClassAccountCE';
import { Helmet } from 'react-helmet-async';

export default function AdminLiveClassAccount() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>{` Live Class Account    | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadcrumbBack title={`Live Class Accounts`}>
        <CustomButton
          onClick={() => setOpen(!open)}
          bg="bg-purple-800"
          title="Create Account"
          icon={true}
          iconName="create"
        />
      </BreadcrumbBack>

      <div className="my-2">
        <PaginationDataGrid name="adminLiveClassAccounts" />
      </div>
      <Models
        name="Create New Live Class Account"
        isOpen={open}
        isClose={setOpen}
      >
        <AdminLiveClassAccountCE type="create" open={setOpen} />
      </Models>
    </>
  );
}
